import { ReactNode } from 'react';
import { FiltersContextProvider } from '../ideas/filters/context/FiltersContext';
import { DiscoveryContextProvider } from '../Discovery/DiscoveryContext';
import { ExplorePage } from './ExplorePage';

interface DiscoveryPageProviderProps {
  children?: ReactNode;
}

/**
 * Wraps the Explore page with discovery and filters context.
 * Used as the element for the /explore route.
 */
export function DiscoveryPageProvider({ children }: DiscoveryPageProviderProps) {
  return (
    <FiltersContextProvider>
      <DiscoveryContextProvider>
        {children ?? <ExplorePage />}
      </DiscoveryContextProvider>
    </FiltersContextProvider>
  );
}
